import React, { PureComponent } from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip } from 'recharts';


export default class Example extends PureComponent {

  render() {

    const data = this.props.data

    return (
        <LineChart
          width={550}
          height={300}
          data={data}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" />
          <YAxis />
          <Tooltip />
          <Line type="monotone" dataKey="uv" stroke="#204f79" />
        </LineChart>
    );
  }
}
